<script lang="ts">
interface Tab {
  key: string
  text?: string
  link?: string
  slot?: boolean
  active?: boolean
}

export type { Tab }
</script>

<script setup lang="ts">
interface Props {
  tabs: Tab[]
}

const props = defineProps<Props>()
const emit = defineEmits<{
  tabClicked: [tab: Tab]
}>()

function tabClicked(tab: Tab) {
  emit('tabClicked', tab)
}
</script>

<template>
  <ul class="tab-nav">
    <li v-for="(tab, index) in props.tabs" class="tab">
      <NuxtLinkLocale
        @click="tabClicked(tab)"
        :href="tab.link" :class="{ active: tab.active }">
        <slot v-if="tab.slot" :name="index" />
        <span v-else>{{ tab.text }}</span>
      </NuxtLinkLocale>
    </li>
  </ul>
</template>

<style scoped lang="scss">
.tab-nav {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  list-style: none;
  font-weight: bold;
}

.tab a {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 12rem;
  padding: 1rem 0;
  border-radius: $border-radius-rounded $border-radius-rounded 0 0;
  background-color: $color-dark-gray;
  @include button-colors($color-white, $color-medium-gray);

  &:hover {
    text-decoration: none;
  }

  &.active, &.router-link-active {
    background-color: $color-white;
    color: $color-black;

    :deep(.icon) { svg { fill: $color-black; } }
  }

  :deep(.icon) {
    margin-bottom: 0.5rem;
    svg { fill: $color-white; }
  }
}
</style>
